export function coordinatesAreEqual(c1, c2) {
  return c1.lng === c2.lng && c1.lat === c2.lat;
}
